import React from "react";
import ContactUs from "../components/commonComponents/contact";
import SEO from "../components/SEO";

function ContactPage() {
  return (
    <>
      <SEO
        title="Contact - Aastha Computers"
        description="Get in touch with Aastha Computes, Bikaner. Reach out for course inquiries, support, or feedback. Our friendly team is here to assist you with all your computer education needs."
        pagePath="/contact"
      />
      <ContactUs />
    </>
  );
}

export default ContactPage;
